import React, {Component} from 'react';

class MobileMegaNav extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      items: props.nav.map((n=> {
        n.active=false;
         return n
       }))
    }
    this.searchFieldRef = null;
    this.maxSearchResults = 15;
    this.toggleParent = props.toggle;

  }


  componentDidUpdate(){
    if(!this.state.open){
        window.onkeyup = function(){}
        return
    }

    window.onkeyup = (e)=>{
      //down -> 40
      //up -> 38
      //right -> 39
      //left -> 37
      //esc->27

      if(e.keyCode === 27 ){
        this.toggleParent();
        this.setState({open:false})
      } //esc

      if(e.keyCode === 40 ){

      }

    }
  }
  componentWillReceiveProps(nextProps) {
    /* it will not likely mount with the menu already */
    nextProps.nav.forEach(i => {
      i.active = false;
    })
    this.setState({items: nextProps.nav, open: nextProps.open})
   }

  toggleSubMenu(i) {
    /* don't forget to close the others */
    this.setState((prevState) => {
      if (prevState.items[i].active) {
        prevState.items.map(item => {
          item.active = false
        })
      } else {
        prevState.items.map(item => {
          item.active = false
        });
        prevState.items[i].active = true;
      }
      return {items: prevState.items}
    })
  }

  toggleMenu = () => {
    this.toggleParent();
    this.setState(function(prevState) {
      return {
        open: !prevState.open
      }
    })
  }

  allClicks(e) {
    if (e.target.classList[0] === 'out-of-menu' || e.target.classList[0] === 'gnm-mobile-mega-nav')
      this.toggleMenu();
  }

  validateSearchField = (e)=>{
    if(e.keyCode == 13)
     this.search()
  }


  search = ()=>{
    let newLocation = `/search?qu=${this.searchFieldRef.value}&num=${this.maxSearchResults}`
    if(this.props.affiliate === 'kwtv') //this is required for local and consumer affairs
      newLocation = 'http://www.news9.com' + newLocation
    else
      newLocation = 'http://www.newson6.com' + newLocation
    document.location = newLocation

  }


  render() {
    return (
      <div className={' gnm-mobile-mega-nav ' + (this.state.open
        ? 'active'
        : '')} onClick={this.allClicks.bind(this)}>
        <div className='container'>
          <div className='out-of-menu row '>
            <div className='col-lg-3 col-md-4 col-sm-4 col-xs-6 dark-background first-column'>
              <div className='row lift'>
               <div className='col-xs-12 search-container'>
                  <div className='input-group'>
                    <input type='text' className='form-control' placeholder='Search'
                      ref={(field)=>{this.searchFieldRef = field}}
                       onKeyDown={this.validateSearchField}/>
                    <span className='input-group-btn' >
                      <button className='btn btn-default' type='button' onClick= {this.search}>
                        <span className='glyphicon glyphicon-search' />
                      </button>
                    </span>
                  </div>
                </div>
              </div>

              {this.state.items.map((navitem, i) => {
                return (
                  <div key={i} onClick={this.toggleSubMenu.bind(this, i)}>
                    <div className=' row lift'>
                      <div className={'main-nav-item exclusive-hover category col-xs-12 hover-color ' + (navitem.active
                        ? 'active'
                        : '')}>
                        <a  href={navitem.url} className="main-nav-link" onClick={(e)=>{

                            e.stopPropagation()
                            e.nativeEvent.stopImmediatePropagation();
                          }}>{navitem.title}</a>
                        <span className={' glyphicon  ' + (navitem.active
                          ? 'glyphicon-minus'
                          : 'glyphicon-plus')} />

                      </div>
                    </div>
                  </div>
                );
              })}
              {this.state.items.map((navitem, i) => {
                return (
                  <div key={i} className={' dark-background subcategory-page ' + (navitem.active
                    ? 'active '
                    : 'inactive')}>

                    <div className={'col-xs-12 inner-border'}>
                      {navitem.url
                        ? (
                          <div className='row hover-color  category subcategory top-level-route'>
                            <a href={navitem.url}>
                              <div className='col-xs-12 tiny-padding-top '>
                                <span>{navitem.title + ' Home'}</span>
                              </div>
                            </a>
                          </div>
                        )
                        : null
                      }

                      {
                        navitem.subItems.map((subitem, j) => {
                          return (
                            <div key={j} className='row hover-color  category subcategory'>
                              <a href={subitem.url} onClick={this.toggleMenu}>
                                <div className='col-xs-12 tiny-padding-top'>
                                  <span >{subitem.title}</span>
                                </div>
                              </a>
                            </div>
                          );
                        })
                    }
                    </div>
                  </div>
                )
              })}
              <div className='subcategory-page dark-background ' />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MobileMegaNav



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Header/MobileMegaNav.js